/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';
import { PianoModal } from './customBlocks/pianoModal';
import { Matrix8x16Modal } from './customBlocks/matrix8x16Modal';

// Las defs del zumbador y del LED RGB las comparten Buty (genera Arduino) y los perfiles FIFA/micro:bit
// (generan JavaScript): la definición es una sola y cada capa de generador aporta la suya.

Blockly.Blocks.BHOOT_piezo_buzzer = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/15.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO);
    this.appendDummyInput()
      // Sin pinName: el zumbador de micro:bit tiene el pin fijo; `pin` es solo lo que muestra el modal.
      .appendField(new PianoModal({
        basePitch: 165, octave: 3, duration: 1000, pin: '12',
      }, undefined, {}), 'PIANO');
    // Sin LANG_SALIDAS_PIEZO_BUZZER_PIANO_SPACE: el preview del piano ya declara su tamaño y esos
    // espacios lo separan de más del texto que sigue.
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZER_PIN);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TOOLTIP);
  },
};

// Igual que BHOOT_piezo_buzzer, pero el generador Arduino omite la duración del tone().
Blockly.Blocks.BHOOT_piezo_buzzer_no_ruration = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/15.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO);
    this.appendDummyInput()
      .appendField(new PianoModal({
        basePitch: 165, octave: 3, duration: 1000, pin: '12',
      }, undefined, {}), 'PIANO');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZER_PIN);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TOOLTIP);
  },
};

Blockly.Blocks.BHOOT_piezo_buzzer_variable = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/15.svg`, options.blockWidth, options.blockHeight));
    this.appendValueInput('VAR')
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO)
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TONE_LC);
    this.appendValueInput('DURATION')
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZER_DURATION);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZER_PIN);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TOOLTIP);
  },
};

Blockly.Blocks.BHOOT_piezo_buzzerno = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/15.svg`, options.blockWidth, options.blockHeight));
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_BHOOT_PIEZO_BUZZERNO);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TOOLTIP);
  },
};

// ------------------------------ LED RGB --------------------------------------

Blockly.Blocks.BHOOT_led_rgb = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/20.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR1')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('COLOUR2').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('COLOUR3').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('COLOUR4').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('COLOUR5').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('COLOUR6').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_LED_RGB_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'ledRGBStrip',
};

// Un solo pixel (POSITION) del módulo de BHOOT_led_rgb; reusa su 'component' para el dropdown de pin.
Blockly.Blocks.BHOOT_led_rgb_single = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/20.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR1')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('POSITION')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB_SINGLE)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB_SINGLE_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_LED_RGB_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'ledRGBStrip',
};

Blockly.Blocks.BHOOT_salidas_led_rgb = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/20.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('DATOINR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_RGB_COLOR);
    this.appendValueInput('DATOING')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_RGB_COLOR_G);
    this.appendValueInput('DATOINB')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_RGB_COLOR_B);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_RGB_PWM)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_RGB_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'ledRGBStrip',
};

// ------------------------------ Cronometro -----------------------------------

Blockly.Blocks.BHOOT_chronometer = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_CONTROL_CHRONOMETER);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_CONTROL_CHRONOMETER_TOOLTIP);
  },
};

Blockly.Blocks.BHOOT_chronometer_millis = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_CONTROL_CHRONOMETER_MILLIS);
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_CONTROL_CHRONOMETER_MILLIS_TOOLTIP);
  },
};

// ------------------------------ Servos ---------------------------------------
// setOutput(true, 'Boolean') va como string: el constructor Boolean no funciona como check en v13.

Blockly.Blocks.BHOOT_servo_move = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/14.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MOVE_DEGREES);
    this.appendValueInput('angulo').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MOVE)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_SERVO_MOVE_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo',
};

Blockly.Blocks.BHOOT_servo_move_millis = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/14.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MILLIS_MOVE_DEGREES);
    this.appendValueInput('angulo').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MILLIS_MOVE_MILLIS);
    this.appendValueInput('millis').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MILLIS_MOVE_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_SERVO_MOVE_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo',
};

Blockly.Blocks.BHOOT_servo_read = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/14.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_SERVO_READ)
      .appendField(Blockly.Msg.LANG_SERVO_READ_PIN)
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, 'Boolean');
    this.setTooltip(Blockly.Msg.LANG_SERVO_CONT_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo',
};

// ------------------------------ Sensores luz/color/joystick ------------------
// 'Boolean' va como string: el constructor no funciona como check en v13.

Blockly.Blocks.BHOOT_light_intensity = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/181.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_BHOOT_LIGHT_INTENSITY)
      .appendField(new Blockly.FieldDropdown([
        ['Rojo', 'intensidadColor_R'],
        ['Verde', 'intensidadColor_G'],
        ['Azul', 'intensidadColor_B'],
      ]), 'COLOR');
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LIGHT_INTENSITY_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_LIGHT_INTENSITY_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'color',
};

Blockly.Blocks.BHOOT_light_color = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/181.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_BHOOT_LIGHT_COLOR)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendValueInput('COLOR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LIGHT_COLOR_IS);
    this.setInputsInline(true);
    this.setOutput(true, 'Boolean');
    this.setTooltip(Blockly.Msg.LANG_BHOOT_LIGHT_COLOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'color',
};

Blockly.Blocks.BHOOT_joystick = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/182.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_BHOOT_JOYSTICK)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_BHOOT_JOYSTICK_X, 'analogRead(A1)'],
        [Blockly.Msg.LANG_BHOOT_JOYSTICK_Y, 'analogRead(A0)'],
        [Blockly.Msg.LANG_BHOOT_JOYSTICK_BUTTON, 'analogRead(A7)<500?0:1'],
      ]), 'TYPE');
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_BHOOT_JOYSTICK_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('joystick', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_JOYSTICK_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'joystick',
};

// ------------------------------ Sensores distancia/infrarrojo ----------------
// 'Boolean' va como string: el constructor no funciona como check en v13.

Blockly.Blocks.BHOOT_ultrasonido = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/22.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO);
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('ultrasonic', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'ultrasonicButy',
};

Blockly.Blocks.BHOOT_line_follower = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/19.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('joystick', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendStatementInput('STACK_DERECHA').appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_DERECHA);
    this.appendStatementInput('STACK_CENTRO').appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_CENTRO);
    this.appendStatementInput('STACK_IZQUIERDA').appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_IZQUIERDA);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'lineFollower',
};

Blockly.Blocks.BHOOT_ENTRADAS_infrared = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/52.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_INFRARED)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_ENTRADAS_INFRARED_DETECT)
      .appendField(new Blockly.FieldDropdown([
        ['Blanco', 'white'],
        ['Negro', 'Black'],
      ]), 'COLOR');
    this.setInputsInline(true);
    this.setOutput(true, 'Boolean');
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_INFRARED_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'infrared',
};

// ------------------------------ Motores DC senior ---------------------------
// Los dos "doble" usan pines fijos (MI=7, PWM2=6, PWM1=5, MD=4): el dropdown NPIN está por
// consistencia y el generador nunca lo lee. Con el boardVersion de Buty v2 el generador invierte
// HIGH/LOW y usa map().

Blockly.Blocks.BHOOT_motor_single_speed = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/30.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT || 'Girar a la derecha', '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT || 'Girar a la izquierda', '4'],
        [Blockly.Msg.LANG_MOTOR_TURN_BRAKE || 'Frenar', '6'],
      ]), 'DIR');
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_SINGLE_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('motorPwm', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput('SPEED')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_SPEED);
    this.appendValueInput('PWM').setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_SINGLE_TOOLTIP);
    this.boardVersion = '';
  },
  setBoardVersion: function (version) { this.boardVersion = version; },
  getPins: function () { return ['NPIN']; },
  component: 'motor',
};

Blockly.Blocks.BHOOT_motor_doble = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/022.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_DOUBLE_FORWARD_SHORT || 'Avanzar', '3'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_BACKWARD_SHORT || 'Retroceder', '4'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_RIGHT_SHORT || 'Girar a la derecha', '5'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_LEFT_SHORT || 'Girar a la izquierda', '6'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_BRAKE_SHORT || 'Frenar', '7'],
      ]), 'DIR');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_TOOLTIP);
    this.boardVersion = '';
  },
  setBoardVersion: function (version) { this.boardVersion = version; },
  getPins: function () { return ['NPIN']; },
  component: 'motor',
};

Blockly.Blocks.BHOOT_motor_doble_pwm = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/022.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_DOUBLE_FORWARD_SHORT || 'Avanzar', '3'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_BACKWARD_SHORT || 'Retroceder', '4'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_RIGHT_SHORT || 'Girar a la derecha', '5'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_LEFT_SHORT || 'Girar a la izquierda', '6'],
      ]), 'DIR');
    this.appendDummyInput('SPEED')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_SPEED);
    this.appendValueInput('PWM').setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_TOOLTIP);
    this.boardVersion = '';
  },
  setBoardVersion: function (version) { this.boardVersion = version; },
  getPins: function () { return ['NPIN']; },
  component: 'motor',
};

// ------------------------------ Neopixels senior ----------------------------
// Dos neopixel en el pin 13 (fijo en el generador). LED: '0' izquierda, '1' derecha, '2' ambos.

Blockly.Blocks.BHOOT_led_neopixel = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/11.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL);
    this.appendDummyInput('')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED_BOTH, '2'],
        [Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED_RIGHT, '1'],
        [Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED_LEFT, '0'],
      ]), 'LED');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};

// Igual que BHOOT_led_neopixel, con brillo máximo 255 en vez de 30 (lo aplica el generador).
Blockly.Blocks.BHOOT_led_neopixel_maxBrightness = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/11.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL);
    this.appendDummyInput('')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED_BOTH, '2'],
        [Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED_RIGHT, '1'],
        [Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED_LEFT, '0'],
      ]), 'LED');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};

Blockly.Blocks.BHOOT_led_neopixel_clear = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/11.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_CLEAR);
    this.appendDummyInput('')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED_BOTH, '2'],
        [Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED_RIGHT, '1'],
        [Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED_LEFT, '0'],
      ]), 'LED');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};

// ------------------------------ Matriz 8x16 senior --------------------------

const BHOOT_MATRIX16X8_ROWS = 8;
const BHOOT_MATRIX16X8_COLS = 16;

const emptyBhootMatrix16x8Leds = () => {
  const leds = {};
  for (let i = 0; i < BHOOT_MATRIX16X8_ROWS * BHOOT_MATRIX16X8_COLS; i += 1) {
    leds[i] = false;
  }
  return leds;
};

const BHOOT_BLUETOOTH_TAG_OPTIONS = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'Ñ',
  'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
].map((t) => [t, t]);

Blockly.Blocks.BHOOT_matrix8x16 = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput('')
      .appendField('Matriz 8 x 16')
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M16x8PIN`),
      ), 'M16x8PIN');
    // Centrado: sin eso Blockly deja la imagen, más angosta que el título, pegada a la izquierda.
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.CENTRE)
      .appendField(new Matrix8x16Modal({ leds: emptyBhootMatrix16x8Leds() }, undefined, {}), 'MATRIX');
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.rows = BHOOT_MATRIX16X8_ROWS;
    this.cols = BHOOT_MATRIX16X8_COLS;
  },
  getPins: function () { return ['M16x8PIN']; },
  component: 'I2C',
  // Sin saveExtraState: el estado vive en el valor del campo. loadExtraState solo migra proyectos
  // que guardaron { leds } en el extra state.
  loadExtraState: function (state) {
    if (state?.leds) {
      this.getField('MATRIX').setValue({ leds: state.leds });
    }
  },
};

// ------------------------------ Bluetooth senior ----------------------------
// Usan SoftwareSerial (BT1) en los pines 9/8, no el Serial nativo. bluetooth_name lleva boardVersion
// porque el generador emite otros comandos AT para Buty v2.

Blockly.Blocks.BHOOT_blue_read_tag = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_NUMBER, 'number'],
        [Blockly.Msg.LANG_STRING, 'text'],
      ]), 'TYPE');
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_BLUE_TAG_WITHTAG)
      .appendField(new Blockly.FieldDropdown(BHOOT_BLUETOOTH_TAG_OPTIONS), 'TAG');
    // Explícito: sin esto v13 parte el bloque en dos filas al ver dos DummyInput seguidos
    // (Block.getInputsInline), y prod lo dibuja en una.
    this.setInputsInline(true);
    this.setOutput(true);
  },
};

Blockly.Blocks.BHOOT_serial_blue_tag = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('CONTENT')
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_BLUE_TAG);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_BLUE_TAG_WITHTAG)
      .appendField(new Blockly.FieldDropdown(BHOOT_BLUETOOTH_TAG_OPTIONS), 'TAG');
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};

Blockly.Blocks.BHOOT_bt_serial_available = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BHOOT_BT_SERIAL_AVAILABLE);
    this.appendStatementInput('DO');
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_BT_SERIAL_AVAILABLE_TOOLTIP);
  },
};

Blockly.Blocks.BHOOT_bluetooth_name = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('name')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_BLUETOOTH_NAME);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_BLUETOOTH_NAME_TOOLTIP);
    this.boardVersion = '';
  },
  setBoardVersion: function (version) { this.boardVersion = version; },
};
